(() => {
  if (customElements.get('multicolumn-grid-slider')) return;

  class MulticolumnGridSlider extends HTMLElement {
    constructor() {
      super();
      this.mobileSlider = null;
      this.desktopSlider = null;
    }

    connectedCallback() {
      this.mobileLayout = this.dataset.mobileLayout || 'grid';
      this.desktopLayout = this.dataset.desktopLayout || 'slider';
      this.colGapMobile = parseInt(this.dataset.colGapMobile, 10) || 8;
      this.colGapDesktop = parseInt(this.dataset.colGapDesktop, 10) || 16;
      this.desktopSlides = parseFloat(this.dataset.desktopSlides) || 4;
      this.mobilePeek = parseFloat(this.dataset.mobilePeek) || 1.5;

      this.mq = window.matchMedia('(max-width: 989px)');
      this.mq.addEventListener('change', this._onBreakpoint.bind(this));

      this._initForViewport();
    }

    disconnectedCallback() {
      this._destroyAll();
    }

    _initForViewport() {
      if (this.mq.matches) {
        this._destroyDesktop();
        if (this.mobileLayout === 'slider') this._initMobileSlider();
      } else {
        this._destroyMobile();
        if (this.desktopLayout === 'slider') this._initDesktopSlider();
      }
    }

    _gridEl() {
      return this.querySelector('[data-grid]');
    }

    _tilesEl() {
      return this.querySelector('[data-tiles]');
    }

    _addSwiperClasses() {
      const grid = this._gridEl();
      const tiles = this._tilesEl();
      if (grid) grid.classList.add('swiper');
      if (tiles) tiles.classList.add('swiper-wrapper');
      this.querySelectorAll('.mcgs__tile').forEach((t) => t.classList.add('swiper-slide'));
    }

    _removeSwiperClasses() {
      const grid = this._gridEl();
      const tiles = this._tilesEl();
      if (grid) grid.classList.remove('swiper');
      if (tiles) tiles.classList.remove('swiper-wrapper');
      this.querySelectorAll('.mcgs__tile').forEach((t) => t.classList.remove('swiper-slide'));
    }

    _initMobileSlider() {
      if (this.mobileSlider) return;
      const grid = this._gridEl();
      if (!grid) return;

      this._addSwiperClasses();

      this.mobileSlider = new Swiper(grid, {
        slidesPerView: this.mobilePeek,
        spaceBetween: this.colGapMobile,
        loop: false,
      });
    }

    _initDesktopSlider() {
      if (this.desktopSlider) return;
      const grid = this._gridEl();
      if (!grid) return;

      this._addSwiperClasses();

      const prevEl = this.querySelector('.mcgs__prev');
      const nextEl = this.querySelector('.mcgs__next');

      this.desktopSlider = new Swiper(grid, {
        slidesPerView: this.desktopSlides,
        spaceBetween: this.colGapDesktop,
        loop: false,
        navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
      });
    }

    _destroyMobile() {
      if (this.mobileSlider) {
        this.mobileSlider.destroy(true, true);
        this.mobileSlider = null;
        this._removeSwiperClasses();
      }
    }

    _destroyDesktop() {
      if (this.desktopSlider) {
        this.desktopSlider.destroy(true, true);
        this.desktopSlider = null;
        this._removeSwiperClasses();
      }
    }

    _destroyAll() {
      this._destroyMobile();
      this._destroyDesktop();
    }

    _onBreakpoint() {
      this._initForViewport();
    }
  }

  customElements.define('multicolumn-grid-slider', MulticolumnGridSlider);
})();
